import { ColumnSetupType } from "../../../../../../../../../../../../../../storybook/data-grid/utils/types/types";
import { RdsSnapshotSource } from "../../../../../../../../../../../../../../services/cloudchipr.api";

export const rdsSnapshotSourceColumns: ColumnSetupType<RdsSnapshotSource>[] = [
  {
    accessorKey: "name",
    header: "DB Name",
    type: "identifier",
    meta: { sticky: "left", hideFromSettings: true },
  },
  {
    accessorKey: "price_per_month",
    header: "Monthly Price",
    type: "dbPricePerMonth",
  },
  {
    accessorKey: "account",
    header: "Account",
    type: "account",
    size: 220,
  },
  {
    accessorKey: "billable",
    header: "Billable",
    type: "billable",
  },
  {
    accessorKey: "exists",
    header: "DB Status",
    type: "exists",
  },
  {
    accessorKey: "db_price_ratio",
    header: "Snapshots Price Ratio",
    type: "dbPriceRatio",
    headerTooltip:
      "Shows the monthly cost of RDS snapshots as a percentage of the database cost, helping you see how snapshot spending compares to your database. For example, if a database costs $5,000 per month and snapshots total $4,000, the ratio is 80%.",
    size: 250,
  },
  {
    accessorKey: "db_type",
    header: "DB Type",
  },
  {
    accessorKey: "snapshots_count",
    header: "Snapshots per DB",
    minSize: 180,
  },
  {
    accessorKey: "engine",
    header: "DB Engine",
  },
  { accessorKey: "region", header: "Region", type: "withCopy" },
];
